<template>
	<div
		ref="blockListRef"
		class="gedit-block-list gedit-block-list--h5"
		:style="{ paddingBottom: paddingBottom + 'px' }"
	>
		<template v-for="(block, index) in scrollBlocks" :key="block.uid || `${block.id}-${index}`">
			<component
				:is="getBlockComponent(block.type)"
				v-if="getBlockComponent(block.type)"
				:data="block.data"
				:block-id="block.id"
				h5
				:id-key="idKey"
			/>
		</template>

		<div v-if="fixedBottomBlocks.length" class="gedit-block-list__fixed">
			<template v-for="(block, index) in fixedBottomBlocks" :key="block.uid || `${block.id}-fixed-${index}`">
				<component
					:is="getBlockComponent(block.type)"
					v-if="getBlockComponent(block.type)"
					:data="block.data"
					:block-id="block.id"
					h5
					fixed-bottom
					:id-key="idKey"
				/>
			</template>
		</div>
	</div>
</template>

<script>
	import { getBlockComponent } from '../blocks/index.js';
	import { isGlobalPayComponentBlock, splitBlocks } from '../templates.js';

	export default {
		name: 'GEditBlockListRender',
		props: {
			blocks: {
				type: Array,
				default: () => [],
			},
			/** 登录组件高度 */
			loginHostHeight: {
				type: Number,
				default: 0,
			},
			/** 页面 id_key */
			idKey: {
				type: String,
				default: '',
			},
			/**
			 * 全局支付是否已支付（来自 /order/checkGeditPayStatus → overall_pay_status === 1）。
			 * 为 true 时，渲染层会过滤掉所有全局支付组件（pay-unlock*，不含 jumplink）。
			 * 编辑端默认 false，无需任何过滤。
			 */
			globalPayPaid: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				fixedBottomHeight: 0,
			};
		},
		computed: {
			/** 过滤掉已付时的全局支付组件 */
			visibleBlocks() {
				if (!this.globalPayPaid) return this.blocks || [];
				return (this.blocks || []).filter((block) => !isGlobalPayComponentBlock(block?.type));
			},
			scrollBlocks() {
				return splitBlocks(this.visibleBlocks).scrollBlocks;
			},
			fixedBottomBlocks() {
				return splitBlocks(this.visibleBlocks).fixedBottomBlocks;
			},
			paddingBottom() {
				return this.fixedBottomHeight + this.loginHostHeight + 20;
			},
		},
		watch: {
			fixedBottomBlocks: {
				handler() {
					this.$nextTick(() => {
						this.updateFixedBottomHeight();
					});
				},
				immediate: true,
			},
		},
		mounted() {
			this.resizeObserver = new ResizeObserver(() => {
				this.updateFixedBottomHeight();
			});
			this.resizeObserver.observe(this.$el);
		},
		beforeUnmount() {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect();
			}
		},
		methods: {
			getBlockComponent,
			updateFixedBottomHeight() {
				const blockListEl = this.$refs.blockListRef;
				if (!blockListEl) return;

				const fixedEl = blockListEl.querySelector('.gedit-block-list__fixed');
				const fixedHeight = fixedEl?.offsetHeight || 0;

				this.fixedBottomHeight = fixedHeight;
				this.$emit('login-host-bottom-change', fixedHeight);
			},
		},
	};
</script>

<style scoped lang="less">
	.gedit-block-list {
		width: 100%;
		margin-top: 0.4rem;
	}

	.gedit-block-list--h5 .gedit-block-list__fixed {
		position: fixed;
		left: 0;
		right: 0;
		bottom: -1px;
		z-index: 100;
		// padding: 0.16rem 0.24rem calc(0.24rem + env(safe-area-inset-bottom, 0));
		box-sizing: border-box;
		background-color: #fff;
	}
</style>

<style lang="less">
	@import '../styles/block-common.less';
</style>
